import React from "react";
import AppPresenter from "./AppPresenter";

const AppContainer = () => {
  return <AppPresenter />;
};

export default AppContainer;
